module.exports = __webpack_public_path__ + "static/media/U1.02ce94c2.png";